import { render, staticRenderFns } from "./StripeConnect.vue?vue&type=template&id=4e85cd2e"
import script from "./StripeConnect.vue?vue&type=script&lang=js"
export * from "./StripeConnect.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports